var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7428 0H2.26203C1.9198 0.000301844 1.58501 0.111854 1.29829 0.321118C1.01156 0.530383 0.785231 0.828362 0.646766 1.17889C0.508301 1.52942 0.463652 1.91743 0.51824 2.29582C0.572828 2.67422 0.724306 3.02673 0.954288 3.31059L6.79659 10.5071V17.2941C6.79664 17.4268 6.83007 17.5567 6.89305 17.6691C6.95603 17.7815 7.04601 17.8717 7.15267 17.9294C7.23791 17.9765 7.33178 18.0006 7.42683 18C7.57007 17.9999 7.709 17.9451 7.82072 17.8447L9.00242 16.7859L10.9719 15.0212C11.0456 14.9551 11.1051 14.8713 11.146 14.776C11.1869 14.6807 11.2082 14.5763 11.2082 14.4706V10.5071L17.0505 3.31059C17.2805 3.02673 17.432 2.67422 17.4866 2.29582C17.5412 1.91743 17.4965 1.52942 17.3581 1.17889C17.2196 0.828362 16.9933 0.530383 16.7066 0.321118C16.4198 0.111854 16.085 0.000301844 15.7428 0Z",
    fill: "#AEA6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2ae87bc2668fca2766628573daffba7e.svg";
export { ForwardRef as ReactComponent };